
import React from 'react';
import { TranslationContent } from '../types';

interface TargetAudienceProps {
  t: TranslationContent['whoFor'];
}

const TargetAudience: React.FC<TargetAudienceProps> = ({ t }) => {
  return (
    <section id="who-for" className="py-20 md:py-32 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8">{t.title}</h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-10">
              {t.subtitle}
            </p>
            <div className="flex flex-wrap gap-3">
              {t.markets.map(market => (
                <span key={market} className="px-4 py-1.5 bg-slate-100 text-slate-700 rounded-lg text-xs font-bold uppercase tracking-widest border border-slate-200/50">
                  {market}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {t.niches.map((niche, idx) => (
              <div 
                key={idx} 
                className="flex items-center p-6 bg-slate-50 rounded-2xl border border-transparent hover:border-indigo-100 hover:bg-indigo-50/30 transition-all group"
              >
                <div className="w-2.5 h-2.5 bg-indigo-500 rounded-full mr-4 group-hover:scale-125 transition-transform" />
                <span className="font-semibold text-slate-800 leading-tight">{niche}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;